import "./form-tenant.scss";
import { useFormContext } from "react-hook-form";
import { TenantFormSchema } from "@factory/form/form.rule";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import { LabelValue } from "@shared/models/label-value.interface";
import { BUSINESS_TYPE } from "@shared/data/business-type";
import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";
import InputTextareaControl from "@shared/ui/hook-form/input-textarea-control/input-textarea-control";

type InputFormSchema = TenantFormSchema;
export function FormTenant() {
  const { control } = useFormContext<TenantFormSchema>();
  const mappedBusinessType = LabelValue.MapArray(
    BUSINESS_TYPE || [],
    (x) => x.name,
    (x) => x.name
  );

  return (
    <div id="FormTenant" className="tenant">
      <InputControl<InputFormSchema>
        control={control}
        name="owner"
        label="Owner"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter owner"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="slug"
        label="Slug"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter slug"
        hint="Slugs name must be the same in google bucket"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="businessName"
        label="Business Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter businessName"
      />
      <DropdownControl<InputFormSchema>
        control={control}
        name="businessType"
        label="Business Type"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter businessType"
        options={mappedBusinessType}
      />
      <InputTextareaControl<InputFormSchema>
        control={control}
        name="description"
        label="Description"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter description"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="email"
        label="Email"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter email"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="mobileNumber"
        label="Mobile Number"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter mobileNumber"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="website"
        label="Website"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter website"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="rewardsType"
        label="Rewards Type"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter rewardsType"
      />
    </div>
  );
}

export default FormTenant;
